import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ChartAccountsManageDialogComponent } from './chart-accounts-manage-dialog/chart-accounts-manage-dialog.component';
import { ChartAccountsFormComponent } from './chart-accounts-form/chart-accounts-form.component';

@NgModule({
  declarations: [
    ChartAccountsManageDialogComponent,
    ChartAccountsFormComponent
  ],
  exports: [
    ChartAccountsManageDialogComponent,
    ChartAccountsFormComponent
  ],
  imports: [
    SharedModule,
  ]
})
export class ChartAccountsModule { }
